export const styles = {
    ['h0']: 'text-4xl font-bold',
    ['h1']: 'text-3xl font-bold',
    ['h2']: 'text-2xl font-semibold',
    ['h3']: 'text-xl font-semibold',
    ['h4']: 'text-lg font-medium',
    ['p1']: 'text-md',
    ['p2']: 'text-xs',
}